import {types} from './types';

export function setCommonBorderRadius(data) {
  return {
    type: types.SET_BORDER_RADIUS,
    payload: data,
  };
}
